<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Editar Turno <i class="fa fa-clock-o" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form">
      		<div class="ibox-content">
				<div class="row">
            		<div class="form-group col-md-6">
              			<label for="name"><span class="required">*</span> Nome do Turno</label>
              			<input type="text" class="form-control" name="name" v-model="shift.name" id="name" />
            		</div>
					<div class="form-group col-md-6">
						<label for="short_name"><span class="required">*</span> Nome Abreviado</label>
						<input type="text" class="form-control" name="short_name" v-model="shift.short_name" id="short_name">
					</div>
					<div class="form-group col-md-6" id="check-shift">
              			<label for="days">Selecione os dias de trabalho:</label>
              			<ul>
							<li>
								<input type="checkbox" id="sunday" value="sunday" v-model="shift.sunday"> Domingo
							</li>
							<li>
								<input type="checkbox" id="monday" value="monday" v-model="shift.monday"> Segunda-feira
							</li>
							<li>
								<input type="checkbox" id="tuesday" value="tuesday" v-model="shift.tuesday"> Terça-feira
							</li>
							<li>
								<input type="checkbox" id="wednesday" value="wednesday" v-model="shift.wednesday"> Quarta-feira
							</li>
							<li>
								<input type="checkbox" id="thursday" value="thursday" v-model="shift.thursday"> Quinta-feira
							</li>
							<li>
								<input type="checkbox" id="friday" value="friday" v-model="shift.friday"> Sexta-feira
							</li>
							<li>
								<input type="checkbox" id="saturday" value="saturaday" v-model="shift.saturday"> Sábado
							</li>
        			    </ul>
		            </div>
            		<div class="form-group col-md-3">
              			<label for="initial_hour"><span class="required">*</span> Hora Inicial</label>
              			<div class="input-group clockpicker">
                			<input id="initial_hour" type="time-local" v-model="shift.initial_hour" class="form-control" placeholder="hh:mm">
                			<span class="input-group-addon">
                  				<span class="glyphicon glyphicon-time"></span>
                			</span>
              			</div>
            		</div>
					<div class="form-group col-md-3">
              			<label for="final_hour"><span class="required">*</span> Hora Final</label>
              			<div class="input-group clockpicker">
                			<input id="final_hour" type="time-local" v-model="shift.final_hour" class="form-control" placeholder="hh:mm">
                			<span class="input-group-addon">
                  				<span class="glyphicon glyphicon-time"></span>
                			</span>
              			</div>
            		</div>
          		</div>
      		</div>

			<div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/shifts" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                shift: {
                    name: '',
                    initial_hour: '',
                    final_hour: '',
                    sunday: '',
                    monday: '',
                    tuesday: '',
                    wednesday: '',
                    thursday: '',
                    friday: '',
                    saturday: '',

                },
                el: '#check-shift',
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'shifts/' + id;

                self.shift.initial_hour = $('#initial_hour').val();
				self.shift.final_hour = $('#final_hour').val();

                self.$http.put(api, self.shift)
                    .then((response) => {
                        self.$message('Sucesso', `Turno atualizado com sucesso`, 'success');
                        this.$router.push('/shifts');
                    }).catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
            getShift(){
                const self = this;
                const id   = self.$route.params.id;
                const api  = self.$store.state.api + 'shifts/' + id;

                self.$http.get(api)
                    .then((response) => {
                        self.shift = response.data.data[0];
                    })
                    .catch((error) => {
                       self.$message(null, 'Ocorreu um erro ao buscar as informações do turno', 'error');
                    });
            }
        },
        mounted: function(){
            this.getShift();
            $('.clockpicker').clockpicker();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li.inline>input[type="checkbox"] {
    vertical-align: sub;
}

li.inline {
    padding-right: 15px;
}

.no-padding {
    padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Shift/Edit.vue